import {
  Card,
  CardContent,
  Grid,
  FormControl,
  FormLabel,
  OutlinedInput,
  Select,
  MenuItem,
  SelectChangeEvent,
  Button,
  alertTitleClasses,
} from "@mui/material"
import React from "react"
import TextField from "../../components/TextField"
import RadioQuestion from "../../components/RadioQuestion"
import { exists } from "fs"
import { ToastContainer, toast } from 'react-toastify';
import {useState} from "react";


function Eligibility() {
  const h1Style: React.CSSProperties = {
    textAlign: "center",
    marginTop: "50px",
    fontSize: "40px",
  }
  const h3Style: React.CSSProperties = {
    textAlign: "center",
    padding: "5px",
    fontSize: "20px",
    fontWeight: "normal",
    marginBottom: "20px",
  }
  const initialState = {
    fullName: "",
    email: "",
    phone: "",
    dob: "",
    crime: "",
    city: "",
    doc: "",
    case: "",
    violent: "no",
    misOrFel: "misdemeanor",
    statePris: "no",
    arrested: "no",
    fireCamp: "no",
    startFireCamp: "",
    endFireCamp: "",
    fireCampName: "",
    probation: "no",
    probTerms: "no",
    whyExpunge: "",
    otherConvic: "",
    employment: "employed",
    jobTrain: "no",
    resume: "no",
    socialServices: "no",
    anythingElse: ""
  };

  interface State {
    fullName: string
    email: string
    phone: string
    dob: string
    crime: string
    city: string
    doc: string
    case: string
    violent: string
    misOrFel: string
    statePris: string
    arrested: string
    fireCamp: string
    startFireCamp?: string
    endFireCamp?: string
    fireCampName?: string
    probation: string
    probTerms: string
    whyExpunge: string
    otherConvic: string
    employment: string
    jobTrain: string
    resume: string
    socialServices: string
    anythingElse?: string
  }
  const [values, setValues] = React.useState<State>({
    fullName: "",
    email: "",
    phone: "",
    dob: "",
    crime: "",
    city: "",
    doc: "",
    case: "",
    violent: "no",
    misOrFel: "misdemeanor",
    statePris: "no",
    arrested: "no",
    fireCamp: "no",
    startFireCamp: "",
    endFireCamp: "",
    fireCampName: "",
    probation: "no",
    probTerms: "no",
    whyExpunge: "",
    otherConvic: "",
    employment: "employed",
    jobTrain: "no",
    resume: "no",
    socialServices: "no",
    anythingElse: "",
  })
  const handleChange =
    (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setValues({ ...values, [prop]: event.target.value })
    }
  const handleSelectChange =
    (prop: keyof State) => (event: SelectChangeEvent<string>) => {
      setValues({ ...values, [prop]: event.target.value })
    }
  const clearState = () => {
      setValues({ ...initialState });
  };
  const handleSubmit = async (event: React.FormEvent) => {
    console.log("hello")
    const body = {name: values.fullName, dateofbirth: values.dob }
    const emailbody = {
      name: values.fullName,
      email: values.email
    };
    event.preventDefault()
    // alert(JSON.stringify(body)) 
    alert("Form submitted successfully, we will be reaching out shortly with more information!");
    try{
      /*
      const response = await fetch("http://localhost:8000/api/check-if-user-exists", {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
       },
        body: JSON.stringify(body),
        // mode: 'no-cors'
      })
      const parsedRes = await response.json()
      //alert(parsedRes)
      if(parsedRes.alreadyExists) {
        alert("User already exists")
      }
      else{
        */
       /*
        const response2 = await fetch("http://localhost:8000/api/add-user-info", {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
          body: JSON.stringify(body),
          // mode: 'no-cors'
        })
        */

       /*
       old api: "http://localhost:8000/api/send-to-airtable"
       */
        const formData = values
        clearState();
        const response3 = await fetch("https://vercel-express-api-fotmm.vercel.app/api/sendToAirtable", {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
          body: JSON.stringify(formData),
          // mode: 'no-cors'
        })
        //console.log("finished")
        /*
        const response4 = await fetch("http://localhost:8000/api/sendExpungement", {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(emailbody),
          // mode: 'no-cors'
        })
        */


      }
    //}
    catch (error) {
      //alert(error)
      console.error(error)
      event.preventDefault()
    }

    // catch(err
    //   // console.log(parsedRes)
    //   event.preventDefault()
    // // console.log(values)
    
  }
  return (
    <form onSubmit={handleSubmit}>
      <h1 style={h1Style}>Check Eligibility</h1>
      <h3 style={h3Style}>
        <em>Check to see if you're eligible for our expungement program.</em>
      </h3>
      <Card
        sx={{
          width: "80%",
          padding: "20px",
          borderRadius: "20px",
          backgroundColor: "#F8F3ED80",
          boxShadow: "0 0px 20px 0px #bfbfbf",
          m: "auto",
          mb: 3,
        }}
      >
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} sx={{}}>
              <TextField
                required
                label="Full Name"
                value={values.fullName}
                onChange={handleChange("fullName")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                label="Email"
                value={values.email}
                onChange={handleChange("email")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                label="Phone Number"
                value={values.phone}
                onChange={handleChange("phone")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                required
                sx={{
                  width: "100%",
                  padding: "10px",
                  paddingBottom: "0px",
                  paddingTop: "0px",
                }}
              >
                <FormLabel
                  sx={{
                    color: "#6F7482",
                    fontSize: "16px",
                  }}
                >
                  Date of Birth
                </FormLabel>

                <OutlinedInput
                  sx={{
                    borderRadius: "10px",
                    width: "100%",
                    height: "48px",
                    backgroundColor: "white",
                  }}
                  type="date"
                  value={values.dob}
                  onChange={handleChange("dob")}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Crime Convicted of"
                required
                value={values.crime}
                onChange={handleChange("crime")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="City of Conviction"
                required
                value={values.city}
                onChange={handleChange("city")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                required
                sx={{
                  width: "100%",
                  padding: "10px",
                  paddingBottom: "0px",
                  paddingTop: "0px",
                }}
              >
                <FormLabel
                  sx={{
                    color: "#6F7482",
                    fontSize: "16px",
                  }}
                >
                  Date of Conviction
                </FormLabel>

                <OutlinedInput
                  sx={{
                    borderRadius: "10px",
                    width: "100%",
                    height: "48px",
                    backgroundColor: "white",
                  }}
                  type="date"
                  value={values.doc}
                  onChange={handleChange("doc")}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Case Number"
                required
                value={values.case}
                onChange={handleChange("case")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <RadioQuestion
                required
                question="Were you convicted for a violent offense?"
                ans1="no"
                ans2="yes"
                label1="No"
                label2="Yes"
                value={values.violent}
                onChange={handleChange("violent")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <RadioQuestion
                required
                question="Were you convicted of a misdemeanor or a felony?"
                ans1="misdemeanor"
                ans2="felony"
                label1="Misdemeanor"
                label2="Felony"
                value={values.misOrFel}
                onChange={handleChange("misOrFel")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <RadioQuestion
                required
                question="Did you serve time in state prison?"
                ans1="no"
                ans2="yes"
                label1="No"
                label2="Yes"
                value={values.statePris}
                onChange={handleChange("statePris")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <RadioQuestion
                required
                question="Have you been arrested since your last conviction?"
                ans1="no"
                ans2="yes"
                label1="No"
                label2="Yes"
                value={values.arrested}
                onChange={handleChange("arrested")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <RadioQuestion
                required
                question="Did you attend Fire Camp?"
                ans1="no"
                ans2="yes"
                label1="No"
                label2="Yes"
                value={values.fireCamp}
                onChange={handleChange("fireCamp")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Name of Fire Camp (if attended)"
                required={false}
                value={values.fireCampName}
                onChange={handleChange("fireCampName")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                sx={{
                  width: "100%",
                  padding: "10px",
                  paddingBottom: "0px",
                  paddingTop: "0px",
                }}
              >
                <FormLabel
                  sx={{
                    color: "#6F7482",
                    fontSize: "16px",
                  }}
                >
                  Start Date of Fire Camp (if attended)
                </FormLabel>

                <OutlinedInput
                  sx={{
                    borderRadius: "10px",
                    width: "100%",
                    height: "48px",
                    backgroundColor: "white",
                  }}
                  type="date"
                  value={values.startFireCamp}
                  onChange={handleChange("startFireCamp")}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                sx={{
                  width: "100%",
                  padding: "10px",
                  paddingBottom: "0px",
                  paddingTop: "0px",
                }}
              >
                <FormLabel
                  sx={{
                    color: "#6F7482",
                    fontSize: "16px",
                  }}
                >
                  End Date of Fire Camp (if attended)
                </FormLabel>

                <OutlinedInput
                  sx={{
                    borderRadius: "10px",
                    width: "100%",
                    height: "48px",
                    backgroundColor: "white",
                  }}
                  type="date"
                  value={values.endFireCamp}
                  onChange={handleChange("endFireCamp")}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <RadioQuestion
                required
                question="Are you currently on probation?"
                ans1="no"
                ans2="yes"
                label1="No"
                label2="Yes"
                value={values.probation}
                onChange={handleChange("probation")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <RadioQuestion
                required
                question="Did you comply with the terms of your probation?"
                ans1="no"
                ans2="yes"
                label1="No"
                label2="Yes"
                value={values.probTerms}
                onChange={handleChange("probTerms")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid item xs={12} sx={{ marginBottom: "5%" }}>
                <TextField
                  label="Why are you seeking expungement? (i.e. job, housing, etc.)"
                  required
                  value={values.whyExpunge}
                  onChange={handleChange("whyExpunge")}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl
                  required
                  sx={{
                    width: "100%",
                    padding: "10px",
                    paddingBottom: "0px",
                    paddingTop: "0px",
                  }}
                >
                  <FormLabel
                    sx={{
                      color: "#6F7482",
                      fontSize: "16px",
                    }}
                  >
                    What best describes your employment situation?
                  </FormLabel>
                  <Select
                    id="demo-simple-select"
                    value={values.employment}
                    onChange={handleSelectChange("employment")}
                    sx={{
                      borderRadius: "10px",
                      width: "100%",
                      height: "48px",
                      backgroundColor: "white",
                    }}
                  >
                    <MenuItem value="employed">Employed</MenuItem>
                    <MenuItem value="unemployed">Unemployed</MenuItem>
                    <MenuItem value="searching">Job Searching</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                required
                sx={{
                  width: "100%",
                  padding: "10px",
                  paddingBottom: "0px",
                  paddingTop: "0px",
                }}
              >
                <FormLabel
                  sx={{
                    color: "#6F7482",
                    fontSize: "16px",
                  }}
                >
                  Do you have any other convictions to consider?
                </FormLabel>
                <OutlinedInput
                  sx={{
                    borderRadius: "10px",
                    width: "100%",
                    backgroundColor: "white",
                  }}
                  value={values.otherConvic}
                  onChange={handleChange("otherConvic")}
                  multiline
                  rows={5}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid item xs={12} sx={{ marginBottom: "5%" }}>
                <RadioQuestion
                  required
                  question="Are you interested in job-readiness or job-training?"
                  ans1="no"
                  ans2="yes"
                  label1="No"
                  label2="Yes"
                  value={values.jobTrain}
                  onChange={handleChange("jobTrain")}
                />
              </Grid>
              <Grid item xs={12} sx={{ marginBottom: "5%" }}>
                <RadioQuestion
                  required
                  question="Do you need help with resume writing?"
                  ans1="no"
                  ans2="yes"
                  label1="No"
                  label2="Yes"
                  value={values.resume}
                  onChange={handleChange("resume")}
                />
              </Grid>
              <Grid item xs={12}>
                <RadioQuestion
                  required
                  question="Are you interested in any other social services help (ie. unemployment or food stamps)?"
                  ans1="no"
                  ans2="yes"
                  label1="No"
                  label2="Yes"
                  value={values.socialServices}
                  onChange={handleChange("socialServices")}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                sx={{
                  width: "100%",
                  padding: "10px",
                  paddingBottom: "0px",
                  paddingTop: "0px",
                }}
              >
                <FormLabel
                  sx={{
                    color: "#6F7482",
                    fontSize: "16px",
                  }}
                >
                  Is there anything else we should know?
                </FormLabel>
                <OutlinedInput
                  sx={{
                    borderRadius: "10px",
                    width: "100%",
                    backgroundColor: "white",
                  }}
                  value={values.anythingElse}
                  onChange={handleChange("anythingElse")}
                  multiline
                  rows={9}
                />
              </FormControl>
            </Grid>
            <Button
              type="submit"
              sx={{
                background: "#4c8066",
                boxShadow: " 0px 0px 10px rgba(0, 0, 0, 0.25)",
                borderRadius: "10px",
                padding: "10px 30px 10px 30px",
                color: "#ffffff",
                width: "20%",
                margin: "auto",
                marginTop: "15px",
              }}
            >
              Submit
            </Button>
          </Grid>
        </CardContent>
      </Card>
    </form>
  )
}

export default Eligibility
